import { ChevronDown } from 'lucide-react';
import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from '../lib/cn';

/** Select nativo estilizado. Suficiente para a Fase 0; Radix Select entra quando precisar de busca. */
export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  function Select({ className, children, ...props }, ref) {
    return (
      <div className="relative">
        <select
          ref={ref}
          className={cn(
            'h-control w-full appearance-none rounded border border-border-strong bg-surface-1 pl-pad-x pr-8 text-base text-text-1 transition-[border-color,box-shadow] duration-(--dur-fast) focus:border-accent focus:shadow-glow focus:outline-none',
            className,
          )}
          {...props}
        >
          {children}
        </select>
        <ChevronDown
          className="pointer-events-none absolute right-2.5 top-1/2 size-4 -translate-y-1/2 text-text-3"
          aria-hidden
        />
      </div>
    );
  },
);
